<template>
  <button 
    v-if="showInstallButton" 
    class="install-button" 
    @click="installPwa"
    title="Install App"
  >
    <font-awesome-icon icon="fa-solid fa-download" />
    <span class="install-text">Install</span>
  </button>
</template>

<script>
import { 
  isRunningAsPwa, 
  isPwaInstallable, 
  setupPwaInstallListener, 
  showPwaInstallPrompt 
} from '@/utils/pwaUtils';

export default {
  name: 'PwaInstallButton',
  data() {
    return {
      isInstallable: false
    };
  },
  computed: {
    showInstallButton() {
      // Show the button only if the app is not running as a PWA and is installable
      return !isRunningAsPwa() && this.isInstallable;
    }
  },
  mounted() {
    // Set up the beforeinstallprompt event listener
    setupPwaInstallListener();
    
    // Check if the app is installable initially
    this.isInstallable = isPwaInstallable();
    
    // Set up a listener to update the installable state when it changes
    window.addEventListener('beforeinstallprompt', () => {
      this.isInstallable = true;
    });
    
    // If the app is installed, we should hide the button
    window.addEventListener('appinstalled', () => {
      this.isInstallable = false;
    });
  },
  methods: {
    async installPwa() {
      try {
        const installed = await showPwaInstallPrompt();
        if (installed) {
          console.log('PWA installation successful');
        } else {
          console.log('PWA installation dismissed');
        }
      } catch (error) {
        console.error('Error installing PWA:', error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.install-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: var(--accent-primary);
  color: #fff;
  border: none;
  border-radius: var(--radius-button);
  padding: 5px 15px;
  margin-left: 10px;
  cursor: pointer;
  font-size: 14px;
  transition: var(--transition);
}
.install-button:hover { background-color: var(--accent-primary-hover); }

.install-text { margin-left: 5px; }
@media only screen and (max-width: 700px) {
  .install-text { display: none; }
}
</style>